import { useEffect } from 'react';
import { registerBroadcast } from 'util/broadcast';
import useMultiScreen from './useMultiScreen';

const useMultiScreenRegister = () => {
  const multiScreen = useMultiScreen();
  useEffect(() => {
    if (multiScreen) {
      const channel = registerBroadcast();
      return () => channel.close();
    }
  }, [multiScreen]);
};

export default useMultiScreenRegister;
